import Vue from 'vue';
import store from './lib/Store.js';
import Cookies from 'js-cookie'
import router from './router';
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import moment from 'moment';

import App from './App.vue';

/* Cookie Popup Components */
import CookiePopups from './components/CookiePopups.vue';
import BottomCheckboxes from './components/cookie-popups/BottomCheckboxes.vue';
import SimpleBottom from './components/cookie-popups/SimpleBottom.vue';
import FriendlyPopup from './components/cookie-popups/FriendlyPopup.vue';
import BlockingPopup from './components/cookie-popups/BlockingPopup.vue';
import NewThemePopup from './components/cookie-popups/NewThemePopup.vue';
import NewMemberPopup from './components/cookie-popups/NewMemberPopup.vue';

/* Feed Components */
import MobileFeedSwitch from './components/MobileFeedSwitch.vue';
import FeedSwitch from './components/FeedSwitch.vue';
import DisplayMode from './components/DisplayMode.vue';
import NewPost from './components/community/NewPost.vue';
import NewPostImages from './components/community/NewPostImages.vue';
import GroupsSlider from './components/community/GroupsSlider.vue';
import EventSlider from './components/community/EventSlider.vue';
import Feed from './components/community/Feed.vue';
import MoodFeed from './components/MoodFeed.vue';
import MoodView from './components/MoodView.vue';
import Topic from './components/community/Topic.vue';
import TopicScrollToNewest from './components/topics/TopicScrollToNewest.vue';
import TopicHelpdeskStatusSwitch from './components/topics/TopicHelpdeskStatusSwitch.vue';
import TopicTopMeta from './components/topics/TopicTopMeta.vue';
import GroupTopic from './components/community/GroupTopic.vue';
import MoodviewTopicTop from './components/topics/MoodviewTopicTop.vue';
import TopicUserIcon from './components/topics/TopicUserIcon.vue';
import TopicContent from './components/topics/TopicContent.vue';
import TopicStats from './components/topics/TopicStats.vue';
import Comments from './components/comments/Comments.vue';
import Comment from './components/community/Comment.vue';
import Reply from './components/community/Reply.vue';
import HuddleEditorImages from './components/HuddleEditorImages.vue';
import HuddleEditorV2 from './components/HuddleEditorV2.vue';
import HuddleEditorV2Main from './components/HuddleEditorV2Main.vue';
import HelpdeskFilter from './components/HelpdeskFilter.vue';
import AjaxSpinner from './components/AjaxSpinner.vue';
import TopicError from './components/TopicError.vue';
import MiniBox from './components/messenger/miniBox/Index.vue';
import Channel from './lib/models/Channel';

import BirthdayTopic from './components/topics/BirthdayTopic.vue';
import IntroductionTopic from './components/topics/IntroductionTopic.vue';

import DateTimePickerWrapper from './components/DateTimePickerWrapper.vue';

/* Menu Components */
import AppearLoggedIn from './components/AppearLoggedIn.vue';
import MenuSearch from './components/MenuSearch.vue';
import FullScreenSearch from './components/FullScreenSearch.vue';
import Tracker from './components/shared/Tracker.vue';

/* Search component */
import UserSearch from './components/UserSearch.vue';

/* Sidebar component */
import BlogFeed from './components/BlogFeed.vue'
import LightBox from './components/shared/LightBox.vue'
import NavBoards from './components/nav/NavBoards.vue'
import NavGroups from './components/nav/NavGroups.vue'
import NavMoodboards from './components/nav/NavMoodboards.vue'

/* Trophy components */
import Trophy from './components/trophy/Trophy.vue';
import TrophyHexagon from './components/trophy/TrophyHexagon.vue';
import TrophyCircle from './components/trophy/TrophyCircle.vue';
import TrophyOverview from './components/trophy/TrophyOverview.vue';
import TrophyFire from './components/trophy/TrophyFire.vue';
import TrophyList from './components/trophy/TrophyList.vue';
import AchievedTrophies from './components/trophy/AchievedTrophies.vue';

import MobileAppMessage from './components/MobileAppMessage.vue';

/* Quiz components */
import Quiz from './components/quiz/Quiz.vue';
import QuizStart from './components/quiz/formElements/QuizStart.vue';
import QuizBottom from './components/quiz/formElements/QuizBottom.vue';
import QuizQuestion from './components/quiz/formElements/Question.vue';
import QuizTop from './components/quiz/formElements/QuizTop.vue';
import MultipleChoice from './components/quiz/formElements/MultipleChoice.vue';
import TrueFalse from './components/quiz/formElements/TrueFalse.vue';
import FreeForm from './components/quiz/formElements/FreeForm.vue';
import QuestionMedia from './components/quiz/formElements/QuestionMedia.vue';
import QuizTimer from './components/quiz/formElements/QuizTimer.vue';
import QuizEnd from './components/quiz/formElements/QuizEnd.vue';
import QuizTimeRanOut from './components/quiz/formElements/TimeRanOut.vue';

/* Poll components */
import Poll from './components/poll/Poll.vue';
import PollMultipleChoice from './components/poll/formElements/PollMultipleChoice.vue';
import PollQuestion from './components/poll/formElements/PollQuestion.vue';

import SmoothReflow from './components/SmoothReflow';

/* Support components */
import SupportIndex from './components/support/SupportIndex.vue';

/* Event components */
import UpcomingEvents from './components/events/community/UpcomingEvents.vue';
import EventIcon from './components/events/community/EventIcon.vue';

/* UI components */
import TabMenu from './components/nav/v2/TabMenu.vue';
import SidebarTab from './components/ui/FormSidebarTab.vue';
import SidebarActionBtn from './components/ui/FormSidebarActionBtn.vue';
import UserAvatar from './components/ui/UserAvatar.vue';
import CustomForm from './components/ui/Form';
import ClickableIcon from './components/ui/ClickableIcon';
import FormRow from './components/ui/input/FormRow.vue';
import FormField from './components/ui/input/FormField.vue';
import FormFieldRow from './components/ui/input/FormFieldRow.vue';
import FormInput from './components/ui/input/FormInput';
import FormTextarea from './components/ui/input/FormTextarea';
import FormSwitch from './components/ui/input/FormSwitch';
import FormCheckbox from './components/ui/input/FormCheckbox';
import FormSelect from './components/ui/FormSelect';
import DropdownMenu from './components/ui/DropdownMenu.vue';
import DropdownMenuItem from './components/ui/DropdownMenuItem.vue';
import Toaster from './components/ui/Toaster.vue';
import ProfileEmailField from './components/ui/ProfileEmailField.vue';

/* Onboarding components */
import OnboardingModals from './components/onboarding/OnboardingModals.vue';

/* Clamp package */
import lineClamp from 'vue-line-clamp';

/* Plugins */
import Translations from '@/resources/assets/js/vue/lib/plugins/translations';
import Settings from '@/resources/assets/js/vue/lib/plugins/settings';
import Echo from 'laravel-echo';

/* Currency format package */
import VueCurrencyFilter from 'vue-currency-filter';

window.pluralize = require('pluralize');

//import stickySidebar to fix previous page bug, in case vue is loaded before the plugins are
// import StickySidebar from '../../../../public/js/core/sticky-sidebar.js'

require('./lib/polyfills/replace-all.js');

Vue.use(require('vue-moment'));

Vue.use(VueCurrencyFilter);

Vue.component('app', App);

/* Vee-validate components */
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

/*  Cookie Popup Components
    Only simplebottom and blockingpopup are currently active  */
Vue.component('cookie-popups', CookiePopups);
Vue.component('bottomcheckboxes', BottomCheckboxes);
Vue.component('simplebottom', SimpleBottom);
Vue.component('friendlypopup', FriendlyPopup);
Vue.component('blockingpopup', BlockingPopup);
Vue.component('newthemepopup', NewThemePopup);
Vue.component('newmemberpopup', NewMemberPopup);

Vue.component('mobile-app-message', MobileAppMessage);

/* Feed Components */
Vue.component('mobilefeedswitch', MobileFeedSwitch);
Vue.component('feedswitch', FeedSwitch);
Vue.component('displaymode', DisplayMode);
Vue.component('events-slider', EventSlider);
Vue.component('newpost', NewPost);
Vue.component('new-post-images', NewPostImages);
Vue.component('groups-slider', GroupsSlider);
Vue.component('feed', Feed);
Vue.component('moodfeed', MoodFeed);
Vue.component('moodview', MoodView);
Vue.component('topic', Topic);
Vue.component('birthday-topic', BirthdayTopic);
Vue.component('topic-scroll-to-newest', TopicScrollToNewest);
Vue.component('topic-helpdesk-status-switch', TopicHelpdeskStatusSwitch);
Vue.component('topic-top-meta', TopicTopMeta);
Vue.component('group-topic', GroupTopic);
Vue.component('moodview-topic-top', MoodviewTopicTop);
Vue.component('topic-user-icon', TopicUserIcon);
Vue.component('topic-content', TopicContent);
Vue.component('topic-stats', TopicStats);
Vue.component('comments', Comments);
Vue.component('comment', Comment);
Vue.component('reply', Reply);
Vue.component('huddle-editor-images', HuddleEditorImages);
Vue.component('huddle-editor-v2', HuddleEditorV2);
Vue.component('huddle-editor-v2-main', HuddleEditorV2Main);
Vue.component('helpdeskfilter', HelpdeskFilter);
Vue.component('ajaxspinner', AjaxSpinner);
Vue.component('topicerror', TopicError);
Vue.component('mini-box', MiniBox);

/* Special feed components */
Vue.component('birthdaytopic', BirthdayTopic);
Vue.component('introductiontopic', IntroductionTopic);

/* Trophy Components */
Vue.component('trophy', Trophy);
Vue.component('trophyHexagon', TrophyHexagon);
Vue.component('trophyCircle', TrophyCircle);
Vue.component('trophyoverview', TrophyOverview);
Vue.component('trophyfire', TrophyFire);
Vue.component('trophylist', TrophyList);
Vue.component('achievedtrophies', AchievedTrophies);

/* Menu components */
Vue.component('appear-logged-in', AppearLoggedIn);
Vue.component('menu-search', MenuSearch);
Vue.component('fullscreensearch', FullScreenSearch);
Vue.component('tracker', Tracker);

Vue.component('user-search', UserSearch);

Vue.component('date-time-picker-wrapper', DateTimePickerWrapper);

/* Sidebar component */
Vue.component('blogfeed', BlogFeed);
Vue.component('lightbox', LightBox);
Vue.component('nav-boards', NavBoards);
Vue.component('nav-moodboards', NavMoodboards);
Vue.component('nav-groups', NavGroups);

/* Quiz components */
Vue.component('quiz', Quiz);
Vue.component('quiz-start', QuizStart);
Vue.component('quiz-bottom', QuizBottom);
Vue.component('quiz-question', QuizQuestion);
Vue.component('quiz-top', QuizTop);
Vue.component('multiple_choice', MultipleChoice);
Vue.component('true_false', TrueFalse);
Vue.component('free_form', FreeForm);
Vue.component('question-media', QuestionMedia);
Vue.component('quiz-timer', QuizTimer);
Vue.component('quiz-end', QuizEnd);
Vue.component('quiz-time-ran-out', QuizTimeRanOut);

/* Poll components */
Vue.component('poll', Poll);
Vue.component('poll_multiple_choice', PollMultipleChoice);
Vue.component('poll-question', PollQuestion);

/* Support components */
Vue.component('support-index', SupportIndex);

/* Event components */
Vue.component('upcoming-events', UpcomingEvents);
Vue.component('event-icon', EventIcon);

/* UI components */
Vue.component('tab-menu', TabMenu);
Vue.component('sidebar-tab', SidebarTab);
Vue.component('sidebar-action-btn', SidebarActionBtn);
Vue.component('user-avatar', UserAvatar);
Vue.component('custom-form', CustomForm);
Vue.component('clickable-icon', ClickableIcon);
Vue.component('form-row', FormRow);
Vue.component('form-field', FormField);
Vue.component('form-field-row', FormFieldRow);
Vue.component('form-input', FormInput);
Vue.component('form-textarea', FormTextarea);
Vue.component('form-switch', FormSwitch);
Vue.component('form-checkbox', FormCheckbox);
Vue.component('form-select', FormSelect);
Vue.component('SmoothReflow', SmoothReflow);
Vue.component('dropdown-menu', DropdownMenu);
Vue.component('dropdown-menu-item', DropdownMenuItem);
Vue.component('toaster', Toaster);
Vue.component('profile-email-field', ProfileEmailField);

/* Onboarding components */
Vue.component('onboarding-modals', OnboardingModals);

/* Clamp package */
Vue.use(lineClamp);

/* Global Vue Directives */
// auto focus on input field
Vue.directive('autofocus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el, binding) {
        // Focus the element
        setTimeout(() => {
            if (typeof binding.value === 'undefined' || binding.value === true) {
                el.focus();
            }
        }, 0);
    },
});

/* Active Data Models */
require('./models/Topic');
require('./models/User');
require('./models/Comment');
require('./models/Reply');
require('./models/Like');
require('./models/Board');
require('./models/Subboard');
require('./models/Moodboard');

require('./bootstrap');

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.silent = true;

const app = new Vue({
    el: '#vue-wrapper',
    router,
    store,

    created() {
        window.Pusher = require('pusher-js');

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: `${process.env.VUE_APP_SOKETI_KEY}`,
            cluster: 'eu',
            wsHost: `${process.env.VUE_APP_SOKETI_HOST}`,
            wssHost: `${process.env.VUE_APP_SOKETI_HOST}`,
            encrypted: true,
            forceTLS: true,
            authEndpoint: "/broadcasting/auth",
        });
    },

    mounted() {
        Vue.use(Translations, this.$store);
        Vue.use(Settings, this.$store);

        let settingsVersion = localStorage.getItem('settingsVersion');
        let translationsVersion = localStorage.getItem('translationsVersion');
        let accountVersion = localStorage.getItem('accountVersion');

        if ((settingsVersion && !cachedSettingsVersion) || (cachedSettingsVersion && settingsVersion && (settingsVersion == cachedSettingsVersion))) {
            const storedSettings = localStorage.getItem('settings');
            const _storedSettings = JSON.parse(storedSettings);
            this.$store.commit('setSettings', _storedSettings);
            this.$store.commit('setPlugins', _storedSettings.plugins);
            moment.locale(_storedSettings.locale);
        } else {
            axios.get('/api/v3/settings')
                .then((response) => {
                    this.$store.commit('setSettings', response.data.data);
                    this.$store.commit('setPlugins', response.data.data.plugins);
                    localStorage.setItem('settings', JSON.stringify(response.data.data));
                    localStorage.setItem('settingsVersion', cachedSettingsVersion);
                    moment.locale(response.data.data.locale);
                });
        }

        if (translationsVersion === null || translationsVersion != cachedTranslationsVersion) {
            let randomKey = Math.round(Math.random() * 100000);

            axios.get(`/api/v3/settings?group=translations&hash=${randomKey}`)
                .then((response) => {
                    this.$store.commit('setTranslations', response.data);
                    localStorage.setItem('translations', JSON.stringify(response.data));
                    localStorage.setItem('translationsVersion', randomKey);
                });
        } else {
            const storedTranslations = localStorage.getItem('translations');
            this.$store.commit('setTranslations', JSON.parse(storedTranslations));
        }

        if ((accountVersion && !cachedAccountVersion) || (cachedAccountVersion && accountVersion && (accountVersion == cachedAccountVersion))) {
            const storedAccount = localStorage.getItem('account');
            this.$store.commit('setUser', JSON.parse(storedAccount));
        } else {
            axios.get('/api/v3/profile/me')
                .then((response) => {
                    this.$store.commit('setUser', response.data);
                    localStorage.setItem('account', JSON.stringify(response.data));
                    localStorage.setItem('accountVersion', cachedAccountVersion);
                });
        }

        // get user login settings
        axios.get('/api/v4/notifications/pings')
            .then((response) => {
                Notifier.items = response.data;
                Notifier.updateHTML();

                const inboxCount = response.data.hasOwnProperty(`inbox.${self.user.id}`) ? response.data[`inbox.${self.user.id}`] : 0;
                this.$store.commit('setInboxCount', inboxCount);
            });

        // get boards
        Channel.api().fetch().then(() => {
            this.$store.commit('db/channels/setDataLoaded');
        });

        /*axios.get(`/api/v3/boards?size=9999&type=default`)
            .then((boards) => {
                let data_models = [{
                    model: 'Board',
                    source: 'data',
                }];

                ActiveDataStore.activeDataSetup(data_models, boards.data);
                this.$store.commit('setBoardsLoaded');
            });*/

        //get moodboards
        /*axios.get(`/api/v3/boards?size=9999&type=moodboard`)
            .then((moodboards) => {
                let data_models = [{
                    model: 'Moodboard',
                    source: 'data',
                }];

                ActiveDataStore.activeDataSetup(data_models, moodboards.data);
                this.$store.commit('setMoodboardsLoaded');
            });*/

        this.checkAppearLoggedIn();
    },

    methods: {
        checkAppearLoggedIn() {
            let appear_logged_in_cookie = Cookies.get('has-logged-in-before');

            if (appear_logged_in_cookie !== undefined) {
                let parsed_cookie = JSON.parse(appear_logged_in_cookie);

                if (typeof parsed_cookie.avatar !== "undefined") {
                    this.$store.commit('setAppearLoggedIn', {
                        name: parsed_cookie.firstname,
                        avatar: parsed_cookie.avatar,
                    });
                }
            }
        }
    }
});

window.Store = store;

ActiveDataStore = new ActiveDataStore();

require('./lib/NetCode.js');

window.NetCode = new NetCode({});

let timeout = 20000;

store.netCode = NetCode.initialize({
    timeout: timeout,
    api_base_path: '/q/',
    csrf_token: document.head.querySelector('meta[name="_token"]').content
});
